import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userStatusColor',
})
export class UserStatusColorPipe implements PipeTransform {
  transform(value: unknown): unknown {
    switch (value) {
      case false:
        return 'danger';
      case true:
        return 'success';
    }
    return '';
  }
}
